/* eslint-disable import/prefer-default-export */
export const AUTH_TOKEN_KEY = 'access_token';
